export function visiblePercentage(
  container: HTMLElement | Element | null | undefined,
  target: HTMLElement | Element | null | undefined,
) {
  if (!container || !target) return 0;

  const containerRect = container.getBoundingClientRect();
  const targetRect = target.getBoundingClientRect();

  // if target is completely above or below container
  if (
    targetRect.bottom <= containerRect.top ||
    targetRect.top >= containerRect.bottom
  ) {
    return 0;
    // if target is completely inside container
  } else if (
    targetRect.top >= containerRect.top &&
    targetRect.bottom <= containerRect.bottom
  ) {
    return 1;
    // if target is partially inside container at the top
  } else if (
    targetRect.top < containerRect.top &&
    targetRect.bottom > containerRect.top
  ) {
    return (targetRect.bottom - containerRect.top) / targetRect.height;
    // if target is partially inside container at the bottom
  } else if (
    targetRect.bottom > containerRect.bottom &&
    targetRect.top < containerRect.bottom
  ) {
    return (containerRect.bottom - targetRect.top) / targetRect.height;
  }

  return 1;
}
